import { Icon } from '@buggy/shared'
import { Tooltip } from 'antd'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

interface DataInsufficientProps {
  style?: 'default' | 'compact'
}

const DataInsufficient: FunctionComponent<DataInsufficientProps> = ({
  style = 'default',
}) => {
  const { formatMessage } = useIntl()

  return (
    <Container>
      <Tooltip
        title={[
          formatMessage({ id: 'kol:statistic_insufficient_tooltip' }),
          formatMessage({ id: 'kol:statistic_insufficient_modal_content' }),
        ].join('\n')}
      >
        <Icon fontSize={14} name='alert-circle' />
      </Tooltip>
      {style === 'default' && (
        <Text>{formatMessage({ id: 'kol:statistic_insufficient' })}</Text>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;

  svg {
    color: ${({ theme }): string => theme.colors.text.white};
    fill: ${({ theme }): string => theme.colors.tagStatus.error};
  }
`

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.tagStatus.error};
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`

export default DataInsufficient
